import taxAccountApi from "@/api/taxAccountApi";

const taxAccountStore = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    pageQuery({ commit }, data) {
      return taxAccountApi.pageQuery(data).then((res) => {
        //commit("setDeclareList", res.result);
        return res;
      });
    },
  },
};

export default taxAccountStore;
